import {Outlet, useParams} from 'react-router-dom'
import {parseISO} from 'date-fns'

import styles from './Project.module.scss'
import {isChatUpdates} from 'modules/chat'
import {useGetNotifications} from 'common/api'
import {Paper, Back, TabsPanel, Loader} from 'common/components'
import {Tab} from 'common/types'
import {useGetProject, isLVROverLimit} from '.'

interface TabsProps {
  notifications: any[]
  project: any
}

export default function Project() {
  const params = useParams()
  const {data: notifications} = useGetNotifications()
  const {data: project} = useGetProject(params.uuid)

  return (
    <Paper relative fullHeight>
      <Back to="/projects" />
      {project ? (
        <div className={styles.content}>
          <Tabs notifications={notifications} project={project} />
          <Outlet />
        </div>
      ) : (
        <Loader />
      )}
    </Paper>
  )
}

const Tabs = ({notifications, project}: TabsProps) => {
  const tabs: Tab[] = [
    {
      key: '',
      label: 'About',
      badge:
        (project.status !== 'closed' &&
          new Date() > parseISO(project.maturityDate)) ||
        isLVROverLimit(project)
          ? 'red'
          : undefined,
    },
    {
      key: 'drawdowns',
      label: 'Drawdowns',
    },
    {
      key: 'schedule',
      label: 'Schedule',
    },
    {
      key: 'forecast',
      label: 'Forecast',
    },
    {
      key: 'documents',
      label: 'Documents',
    },
  ]

  return (
    <TabsPanel
      isChatUpdates={isChatUpdates(notifications, project.uuid)}
      title={project.title}
      img={project.image}
      path={`projects/${project.uuid}`}
      tabs={tabs}
    />
  )
}
